import React from 'react';
import { Link } from 'react-router-dom';

/**
 * El hueco reservado para el login de admin.
 *
 * Está vacío A PROPÓSITO: acá no hay autenticación de ningún tipo todavía, y esta
 * ruta no protege nada. Cuando se implemente, el form va acá y el backend de auth
 * es lo que decide — nunca el frontend.
 */
export default function AdminLogin() {
  return (
    <main className="page">
      <span className="badge">pendiente</span>
      <h1>Login de admin</h1>

      <div className="card">
        <p className="muted">
          Todavía no está implementado. El panel de admin va a permitir ver el estado de
          cada watcher, renovar la cookie de sesión y disparar un chequeo a mano.
        </p>
      </div>

      <p className="muted" style={{ marginTop: '2rem' }}>
        <Link to="/">← Volver</Link>
      </p>
    </main>
  );
}
